import { compose, withProps, lifecycle, withHandlers } from 'recompose'
import { connect } from 'react-redux'
import reduxForm from 'components/common/hoc/withFormErrorFocus'
import withType from 'components/common/hoc/withType'
import validate from 'components/AppointmentConfirmationPage/AppointmentInfo/validate'
import BOTAppointmentContactDetails from './BOTAppointmentContactDetails'
import { getAppointmentConfirmationContactDetails, getAppointmentConfirmationFormValues } from './../../selectors'
import { getUserData } from '../../../../Appointment/selectors'
import { storeAppointmentContactDetails } from '../../helpers'
import { submitAppointmentRequest } from '../../actions'
import {
  USER_FIRST_NAME,
  USER_LAST_NAME,
  USER_EMAIL,
  USER_PHONE_NUMBER,
  USER_PLAN_FIELD_NAME,
  USER_PLAN_WAIT
} from 'constant'
import { FORM_NAME } from './../../../constants'
import { setAppointmentResponse } from 'components/QuickAppointmentPage/actions'
import { setAppointmentConfirmationContactDetails } from './../AppointmentInfoDrawer/actions'
import { SUBMIT_ERROR_ID } from '../../constants'
import { KEEP_IN_CONTACT_PROPERTY_NEW } from 'components/Login/CreateAccount/CreateAccountFormPage/constants'
import { getIsEmailMe } from 'components/MyFavorites/selectors.js'

const mapStateToProps = state => ({
  contactDetails: getAppointmentConfirmationFormValues(state),
  storedContactDetails: getAppointmentConfirmationContactDetails(state) || {},
  userData: getUserData(state),
  isEmailMe: getIsEmailMe(state)
})

const getFormInitialValues = (
  {
    accountDetails: {
      lastName: accLastName,
      firstName: accFirstName,
      primaryPhone: {
        areaCode,
        firstThree,
        lastFour
      } = {},
      emailId: accEmail
    } = {}
  } = {},
  {
    [USER_FIRST_NAME]: storedFirstName,
    [USER_LAST_NAME]: storedLastName,
    [USER_EMAIL]: storedEmail,
    [USER_PHONE_NUMBER]: storedPhoneNumber
  } = {}, {
    userEmail,
    email,
    firstName,
    lastName,
    primaryPhoneNumber,
    phoneNumber
  } = {}) => {
  const accPhoneNumber = areaCode ? `${areaCode}${firstThree}${lastFour}` : undefined

  return {
    [USER_FIRST_NAME]: accFirstName || firstName || storedFirstName,
    [USER_LAST_NAME]: accLastName || lastName || storedLastName,
    [USER_PHONE_NUMBER]: accPhoneNumber || primaryPhoneNumber || phoneNumber || storedPhoneNumber,
    [USER_EMAIL]: accEmail || userEmail || email || storedEmail,
    [USER_PLAN_FIELD_NAME]: USER_PLAN_WAIT,
    [KEEP_IN_CONTACT_PROPERTY_NEW]: true
  }
}

const withDataReset = lifecycle({
  componentWillUnmount() {
    const { contactDetails, setAppointmentConfirmationContactDetails, setAppointmentResponse } = this.props
    storeAppointmentContactDetails({ contactDetails, setAppointmentConfirmationContactDetails })
    setAppointmentResponse(null)
  },
  componentDidUpdate({ submitFailed: prevSubmitFailed }) {
    const { submitFailed } = this.props

    if (prevSubmitFailed !== submitFailed || submitFailed) {
      const errorElement = document.getElementById(SUBMIT_ERROR_ID)

      if (!errorElement) return

      errorElement.scrollIntoView({ block: 'center', behavior: 'smooth' })
    }
  }
})

const withInitialValues = withProps(
  ({
    appointmentConfirmationDetails,
    storedContactDetails,
    userData
  }) => ({
    initialValues: getFormInitialValues(appointmentConfirmationDetails, storedContactDetails, userData)
  })
)

const withSubmitHandlers = withHandlers({
  onSubmit: ({
    submitAppointmentRequest
  }) => () => {
    submitAppointmentRequest()
  }
})

export default compose(
  withType({
    type: 'BOTAppointmentContactDetails'
  }),
  connect(mapStateToProps, {
    submitAppointmentRequest,
    setAppointmentResponse,
    setAppointmentConfirmationContactDetails
  }),
  withInitialValues,
  withSubmitHandlers,
  reduxForm({
    validate,
    form: FORM_NAME,
    enableReinitialize: true
  }),
  withDataReset
)(BOTAppointmentContactDetails)
